import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request';
import { KeycloakUser, KeycloakUserCreateDTO } from '@app/core/users';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KeycloakAdminService {
  constructor(private requestService: RequestService) {}

  public getUserData(idOrEmail: string): Observable<KeycloakUser> {
    return this.requestService.get<KeycloakUser>(
      `/api/keycloak-admin/users/${idOrEmail}`
    );
  }

  public changePassword(idOrEmail: string, password: string): Observable<any> {
    return this.requestService.post(
      `/api/keycloak-admin/users/${idOrEmail}/reset-password`,
      {
        password,
      }
    );
  }

  public create(user: KeycloakUserCreateDTO): Observable<KeycloakUser> {
    return this.requestService.post<KeycloakUserCreateDTO>(
      `/api/keycloak-admin/users`,
      user
    );
  }

  public update(
    username: string,
    user: KeycloakUserCreateDTO
  ): Observable<KeycloakUser> {
    return this.requestService.put<KeycloakUserCreateDTO>(
      `/api/keycloak-admin/users/${username}`,
      user
    );
  }
}
